export const environment = {
    production: false,
    apiBaseV1: 'https://al-app-int-online-goh-admintoolapi-preprod.azurewebsites.net/api/v1/',
    apiBaseV2: 'https://al-app-int-online-goh-admintoolapi-preprod.azurewebsites.net/api/v2/',
    apiPrevBaseUrl: 'https://al-app-int-online-goh-admintoolapi-test.azurewebsites.net/api/v1/',
    adminToolApiClientId: '6b6dd235-d375-47f1-b1ce-508266b8624c',
    adminToolClientId: '77cc6e4b-15ef-4648-8811-c2ab3adf770f',
    adminToolTenentId: 'ed5d5f47-52dd-48af-90ca-f7bd83624eb9',
    env: 'preprod',
    prevenv: 'test',
    d365EnricherHost: 'https://api-alfalaval-preprod.azure-api.net/api/v1/d365fo/D365FOLookupService',
    httpDestinationDefaultQueue: 'al-goh-transfer-send-http',
    managedIdentity: {
        name: 'al-uai-int-online-goh-preprod',
        clientId: '61cd68a2-869a-475a-9adb-7569c7a7e477'
    },
    ediIdentifiers: {
        as2: 'ALFALAVAL_TEST',
        x12: 'AL_X12_TEST',
        edifact: 'ALFALAVAL_EDI_TEST',
    },
    azure: {
        subscriptionId: '0e801344-ecc2-4c87-a6a3-5268dab23b87',
        resourceGroup: 'al-rg-int.goh-preprod',
    },
    resources: {
        appInsights: {
            componentName: 'al-ai-int-online-goh-preprod'
        },
        logicApps: {
            siteName: 'al-las-int-online-goh-preprod'
        }
    }
};
